import { Util } from '@grandvisionhq/forms'

export const isValidStreetName = (val: string) => Boolean(/\w.*\d/.exec(val))

export const isPostalCode =
  (country: string) =>
  (value: string): boolean =>
    Util.validations.isValidPostalCodeForCountry(country, value)

const REGEX = {
  ORDER_NUMBER: /^(OR(88|99)-)?([A-Za-z0-9]{8,10})$/,
}
export const isOrderNumber: Util.validations.Validator = (value: string) =>
  REGEX.ORDER_NUMBER.test(value)
